/* Erzeugt aus vp-order-worker (npm run mo:pricing-asset), nicht von Hand ändern. */
window.VPPricingB = (function () {
const MO_WHITE_TEXTILE_CODES = ['AS', 'WW', 'WD', 'WH', 'NB', 'NW', 'RH'];
const r2 = (n) => Math.round((Number(n) + Number.EPSILON) * 100) / 100;

function moScale(scales, qty) {
  if (!scales || !scales.length) return null; const q = Math.max(1, Number(qty) || 1); let best = null;
  for (const s of scales) { const min = Number(s[0]); if (min <= q && (!best || min > Number(best[0]))) best = s; }
  return best || scales.slice().sort((a, b) => Number(a[0]) - Number(b[0]))[0];
}
function moRange(ranges, areaCm2) {
  if (!ranges || !ranges.length) return null;
  const rs = ranges.slice().sort((a, b) => Number(a.area_from) - Number(b.area_from));
  if (rs.length === 1 || areaCm2 == null) return rs.length === 1 ? rs[0] : null;
  const a = Number(areaCm2);
  const hit = rs.find(r => a >= Number(r.area_from) && a < Number(r.area_to)); if (hit) return hit;
  const above = rs.find(r => Number(r.area_to) > a); return above || rs[rs.length - 1];
}
const moIsWhiteTextile = (colorCode) => MO_WHITE_TEXTILE_CODES.includes(String(colorCode || '').toUpperCase());

function moPrintQuote(list, opts) {
  const t = list && list.techniques ? list.techniques[opts.techniqueId] : null; if (!t) return null;
  const qty = Math.max(1, Number(opts.qty) || 1); const positions = Math.max(1, Number(opts.positions) || 1);
  const colours = Math.max(1, Number(opts.colours) || 1); const notes = [];
  const type = t.pricing_type; const byArea = type === 'AreaRange' || type === 'ColourAreaRange' || type === 'Area';
  const range = byArea ? moRange(t.ranges, opts.areaCm2) : (t.ranges && t.ranges[0]) || null; if (!range) return null;
  if (byArea && opts.areaCm2 == null) notes.push('Fläche unbekannt');
  const scale = moScale(range.scales, qty); if (!scale) return null;
  const price = Number(scale[1]) || 0; const next = scale[2] != null ? Number(scale[2]) : null;
  let calcColours = colours;
  if (t.textil_weiss_regel && opts.colorCode && !moIsWhiteTextile(opts.colorCode)) { calcColours = colours + 1; notes.push('Textil nicht weiß: eine Farbe mehr im Druckpreis (weiße Unterlegung)'); }
  let unit, setupUnits;
  if (type === 'NumberOfPositions') { unit = price * positions; setupUnits = positions; }
  else if (type === 'NumberOfColours' || type === 'ColourAreaRange') { unit = t.next_colour && next != null ? price + next * (calcColours - 1) : price * calcColours; setupUnits = colours; }
  else { unit = price; setupUnits = 1; }
  const setupBase = opts.repeat && t.setup_repeat != null ? Number(t.setup_repeat) : (t.setup != null ? Number(t.setup) : 0);
  const setup = r2(setupBase * setupUnits);
  const manip = opts.manipulationCode && list.manipulations ? list.manipulations[opts.manipulationCode] : null;
  const handlingUnit = manip ? Number(manip.price) || 0 : 0;
  unit = r2(unit); const print = r2(unit * qty), handling = r2(handlingUnit * qty);
  return { technique: opts.techniqueId, pricing_type: type, qty, colours, calc_colours: calcColours, positions, scale_min: Number(scale[0]), range_id: range.id || null, unit, print, setup, setup_units: setupUnits, handling_unit: handlingUnit, handling, total: r2(print + setup + handling), repeat: !!opts.repeat, notes };
}

function moPositionTotal(list, qty, prints, manipulationCode) {
  const parts = prints.map(p => moPrintQuote(list, { ...p, qty, manipulationCode: null })).filter(Boolean);
  const manip = manipulationCode && list && list.manipulations ? list.manipulations[manipulationCode] : null;
  const handling = r2((manip ? Number(manip.price) || 0 : 0) * qty);
  const print = r2(parts.reduce((s, p) => s + p.print, 0)), setup = r2(parts.reduce((s, p) => s + p.setup, 0));
  return { parts, print, setup, handling, total: r2(print + setup + handling) };
}

return { moPrintQuote, moScale, moRange, moPositionTotal, moIsWhiteTextile, MO_WHITE_TEXTILE_CODES };
})();
